import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Persiste en localStorage para sobrevivir recargas en el dispositivo
export const useAuthStore = create(
  persist(
    (set) => ({
      isAuthenticated: false,
      token:    null,
      user:     null,   // { _id, name, email, role }
      tenantId: null,
      tenant:   null,   // el comercio elegido al entrar: nombre, giro, plan y lo que su plan incluye

      login: ({ token, user, tenantId, tenant }) =>
        set({ isAuthenticated: true, token, user, tenantId, tenant: tenant ?? null }),

      // Lo que cambió en el servidor desde que se entró: el plan, el giro, el
      // cobro centralizado. Se mezcla sobre lo guardado para no perder campos.
      actualizarTenant: (tenant) =>
        set((s) => (s.isAuthenticated && tenant ? { tenant: { ...s.tenant, ...tenant } } : {})),

      logout: () =>
        set({ isAuthenticated: false, token: null, user: null, tenantId: null, tenant: null }),
    }),
    {
      name:    'gc-pos-auth',
      partialize: (s) => ({ token: s.token, user: s.user, tenantId: s.tenantId, tenant: s.tenant, isAuthenticated: s.isAuthenticated }),
    }
  )
);
